import { gql, useQuery } from "@apollo/client";

export function useGetActivePolicyTags(organisationId: string = null) {
  return useQuery(
    gql`
      query getActivePolicyTags($filter: FilterFindManyCompanyPolicyTagInput) {
        company_policy_tags(filter: $filter) {
          _id
          name
        }
      }
    `,
    {
      variables: {
        filter: {
          organisation_id : organisationId
        }
      },
      fetchPolicy : 'network-only'
    }
  );
}